//frontend/src/dropdownMap/1A4_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "DevPlan",
    10: "SubActivity",
    11: "ConsIdentified",
    13: "ConductedBy",
    18: "Gender",
    20: "PovertyLevel",
    21: "PWDStatus",
    22: "APGMember",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose


    DevPlan: {
        internal: ["plan_no", "plan_yes"],
        LA: { "plan_no": "No", "plan_yes": "Yes" },
        EN: { "plan_no": "No", "plan_yes": "Yes" }
    },
    SubActivity: {
        internal: ["__1", "subact3", "subact4", "subact5", "subact6", "subact7", "subact8", "subact9", "subact10", "subact11", "subact12", "subact13"],
        LA: {
            "__1": "ການສ້າງວັງສະຫງວນ",
            "subact3": "ການລ້ຽງປາດຸກໃນໜອງຜ້າຢ່າງ",
            "subact4": "ການລ້ຽງກົບຢູ່ພື້ນທີ່ປູກຜັກສວນຄົວ",
            "subact5": "ການຜະລິດລູກປານິນໃນກະຊັງ",
            "subact6": "ປູກຫວາຍຂົມ",
            "subact7": "ປູກໜໍ່ຂົມ",
            "subact8": "ປູກໜໍ່ໄມ້ລ້ຽງນ້ອງ",
            "subact9": "ຄຸ້ມຄອງປ່າໜໍ່ຂົມ",
            "subact10": "ຄຸ້ມຄອງປ່າໜໍ່ຫຼອຍ",
            "subact11": "ຄຸ້ມຄອງປ່າໝາກຈອງບານ",
            "subact12": "ປູກໜໍ່ບົງຫວານ",
            "subact13": "ສ້າງສວນກ້າ"
        },
        EN: {
            "__1": "Fishery conservation area establishment",
            "subact3": "Catfish raising in plastic artificial pond",
            "subact4": "Frog raising in home garden",
            "subact5": "Tirapia fingerling production",
            "subact6": "Bitter rattan growing",
            "subact7": "Bitter bamboo growing",
            "subact8": "Bamboo growing",
            "subact9": "“Nor Khom” bamboo area management",
            "subact10": "“Nor Loy” bamboo area management",
            "subact11": "Malva nut area management",
            "subact12": "“Nor bong vahn” bamboo growing",
            "subact13": "Nursery establishment"
        }
    },
    ConsIdentified: {
        internal: ["0", "1", "2", "3"],
        LA: {
            "0": "ບໍ່ມີ",
            "1": "ສ້າງໃໝ່",
            "2": "ຟື້ນຟູ",
            "3": "ສົ່ງເສີມຄົວເຮືອນປູກພືດອາຫານປ່າ"
        },
        EN: {
            "0": "Not available",
            "1": "New",
            "2": "Improved",
            "3": "Promotion / conservation of edible wild species"
        }
    },
    ConductedBy: {
        internal: ["dafo", "gst", "maf", "nafri", "npco", "pafo", "wfp"],
        LA: {
            "dafo": "ຫ້ອງການ ກປ  ເມືອງ",
            "gst": "ທີມງານຊ່ວຍເຫຼືອກຸ່ມ",
            "maf": "ກະຊວງ ກປ",
            "nafri": "ສະຖາບັນຄົ້ນຄວ້າ ກປ",
            "npco": "ຫ້ອງການປະສານງານສູນກາງ",
            "pafo": "ພະແນກ ກປ ແຂວງ",
            "wfp": "ອົງການອາຫານໂລກ"
        },
        EN: { "dafo": "DAFO", "gst": "GST", "maf": "MAF", "nafri": "NAFRI", "npco": "NPCO", "pafo": "PAFO", "wfp": "WFP" }
    },
    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },
    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },
    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },
    APGMember: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA → _male etc.
// export const dropdownReverseMap = {};
// Object.keys(dropdownOptions).forEach(field => {
//     dropdownReverseMap[field] = { LA: {}, EN: {} };
//     const opts = dropdownOptions[field];
//     opts.internal.forEach(intVal => {
//         dropdownReverseMap[field].LA[opts.LA[intVal]] = intVal;
//         dropdownReverseMap[field].EN[opts.EN[intVal]] = intVal;
//     });
// });
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal); // force string
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
